export default `
<div class="view-more-btn">
  <button class="loading" ng-click="$ctrl.loadMore()" ng-hide="$ctrl.isLastPage" ng-class="{started: isLoading}" fade-target="footer">
    {{$ctrl.label}}
  </button>
  <ut-loading-dots ng-if="$ctrl.isLoading"></ut-loading-dots>
</div>
`;
